import type { Client, ClientHeaders } from "@medusajs/js-sdk";

import type { SalonStockerHttpTypes } from "../types";

export class Seller {
  /**
   * @ignore
   */
  private client: Client;
  /**
   * @ignore
   */
  constructor(client: Client) {
    this.client = client;
  }

  /**
   * This method retrieves a list of active sellers. It sends a request to the
   * /store/sellers API route.
   *
   * @param query - Query configurations.
   * @param headers - Headers to pass in the request.
   * @returns The paginated list of sellers.
   */
  list = async (
    query?: SalonStockerHttpTypes.StoreSellerListParams,
    headers?: ClientHeaders
  ): Promise<SalonStockerHttpTypes.StoreSellerListResponse> => {
    return await this.client.fetch<SalonStockerHttpTypes.StoreSellerListResponse>( //
      `/store/sellers`,
      {
        method: "GET",
        query,
        headers
      }
    );
  };
}
